import React from 'react';
import { SkeletonLine } from '@wix/wix-ui-tpa/cssVars';
import classes from './AdditionalDetailsLoader.css';

export const AdditionalDetailsLoader = () => (
  <div className={classes.root}>
    <div className={classes.field}>
      <SkeletonLine className={classes.label} />
      <SkeletonLine className={classes.input} />
    </div>
    <div className={classes.field}>
      <SkeletonLine className={classes.label} />
      <SkeletonLine className={classes.input} />
    </div>
    <div className={classes.field}>
      <SkeletonLine className={classes.label} />
      <SkeletonLine className={classes.input} />
    </div>
  </div>
);
